import React from 'react';
import Item from "../../components/list/Item";
import Button from "../../components/button/Button";
import Meta from "../../components/Meta";

const BookReview = () => {

  return (
    <section className="book-review pt-40">

      <Meta
        title="Database Internals - Book by Alex Petrov"
        desc="A deep dive into how distributed data systems work."
        image="/images/books/database-internals.jpg"
        pageType="book"
        author="Alex Petrov"
      />

      <section className="relative">
        <div className="container ">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="min-w-fit">
              <img
                src="/images/books/database-internals.jpg"
                width="400"
                className="shadow-lg"
              />
              <div className="text-center mt-10">
                <Button title="Read with us" link="/pricing"/>
              </div>
            </div>
            <div className="lg:pr-25">
              <h1 className="font-display text-jacarta-700 text-4xl font-medium dark:text-white">
                Database Internals
              </h1>
              <h2 className="dark:text-jacarta-60 text-lg leading-normal mb-5">
                By <strong>Alex Petrov</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                This is a fantastic book that explains how databases work internally. The book is divided in two parts.
              </p>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                The first part is about Storage Engines and it covers the different techniques that are used to store and retrieve data in a database. You will understand concepts that are important
                as a backend engineer. This section of the book also covers the essentials of how data is store in a disk, it is a fascinating journey to understand more advanced topics.
              </p>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                The second part of the book is about Distributed Systems. This part is focused on how distributed data system works and it will cover things like failure detection, replication and
                consistency, distributed transactions and consensus.
              </p>

              <h2 className="text-jacarta-700 dark:text-white text-lg leading-normal mb-5 mt-10">
                <strong>About Alex Petrov</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                Alex Petrov is a Software Engineer at Apple. He has been working with distributed systems for more than 15 years. He is a Apache Cassandra committer and PMC member.
              </p>

              <h2 className="text-jacarta-700 dark:text-white text-lg leading-normal mb-5 mt-12">
                <strong>A book suggested for</strong>
              </h2>
              <Item
                title=""
                description="This is a book for everyone that work with Databases or Data Distributed Systems."
              />
              <Item
                title=""
                description="For everyone who is interested to know how databases work internally. Even if you are not a database engineer, this book will help you to understand how you can get the most from databases."
              />
            </div>
          </div>
        </div>
      </section>

    </section>
  );
};

export default BookReview;
